<template>
    <span>
        <el-tooltip class="item" effect="dark" content="请先选择商品" :disabled="selectionShopArr.length ? true : false" placement="top">
            <el-button @click="joinShops">加入商品组</el-button>
        </el-tooltip>
        <!-- 创建加入商品组弹框 -->
        <el-dialog :title="shopGroupName" width="25%" :visible.sync="dialogJoinVisible" :append-to-body="true" >
            <p v-if="isDownBox" class="mb-20">{{ '共计' + selectionShopArr.length + '个商品' }}</p>
            <el-form :model="joinFrom" ref="joinFrom" :rules="joinRules">
                <el-form-item label="商品组名称" label-width="100px"  prop="selectShopId" v-if="isDownBox">
                    <join-shop-group ref="downBox" :platformId="platformId" @createShopGroup="createShopGroup" @selectShopFun="selectShopFun"></join-shop-group>
                </el-form-item>
                <el-form-item label="商品组名称" label-width="100px"  prop="shopsName" v-else>
                    <el-input v-model="joinFrom.shopsName"  autocomplete="off" placeholder="请输入商品组名称" maxlength="20" show-word-limit></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogJoinVisible = false">取消</el-button>
                <el-button type="primary" @click="joinConfirm">确认</el-button>
            </div>
        </el-dialog>
    </span>
</template>
<script>
import JoinShopGroup from '@/components/joinShopGroup';
import { joinGroup, createGroup } from "@/api/shopManage";

export default {
    name: 'joinDialog',
    data() {
        return {
            dialogJoinVisible: false,
            joinFrom: {
                selectShopId: '',
                shopsName: '',
            },
            shopGroupName: '加入商品组',
            isDownBox: true,
            joinRules: {
              selectShopId: [
                {required: true, message: '请选择商品组名称', trigger: 'blur'},
              ],
              shopsName:[
                {required: true, message: '请输入商品组名称', trigger: 'blur'},
              ],
            },
        }
    },
    components: {
        JoinShopGroup
    },
    props: {
        selectionShopArr: {
            type: Array,
            default: () => {
                return []
            }
        },
        platformId: {
            type: [String, Number],
            default: ''
        }
    },
    methods: {
        //创建商品组
        createShopGroup() {
            this.isDownBox = false
            this.shopGroupName = '创建商品组'
        },
        createShops() {
          this.dialogCreatedVisible = true
        },
        createConfirm() {
          let createParams = {
            remark: '',
            group_name: this.createdFrom.shopsName,
            product_ids: '',
          }
          this.$emit('selectionShop', createParams)
          this.dialogCreatedVisible = false
        },
        //加入商品组
        joinConfirm() {
            let productIds = this.selectionShopArr.map((item)=> item.product_id).join(",")
            let joinParams = {
                group_id: this.joinFrom.selectShopId,
                product_ids: productIds,
            }
            let createParams = {
                remark: '',
                group_name: this.joinFrom.shopsName,
                product_ids: productIds,
                platform_id: this.platformId
            }
            this.$refs['joinFrom'].validate((valid) => {
                if(valid) {
                    this.selectionShop(this.isDownBox ? joinParams : createParams);
                }
            })
        },
        async joinShops() {
            this.$Bus.$emit('clear')
            if(!this.selectionShopArr.length) return;
            this.joinFrom = {shopsName: ''}
            this.dialogJoinVisible = true
            this.isDownBox = true
           
        },
        //选择商品组名称
        selectShopFun(val) {
          this.$set(this.joinFrom, 'selectShopId', val)
        },
        resetForms(from) {
            this.$refs[from].resetFields();
        },
        //加入商品组
        async selectionShop(val) {
            const {code} = await (this.isDownBox ? joinGroup : createGroup)(val);
            if(code === 0) {
                this.$message.success(val.group_id ? '添加商品成功' : '创建商品组成功');
                this.dialogJoinVisible = false
            }
        },
    }
}
</script>
<style scoped>

</style>